import { useQuery } from '@tanstack/react-query';

import { getUserAccount } from '@arrived/api_v2';
import { Account, AccountId } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { accountsKeyFn } from './accounts.keys';

export function useGetAccountQuery(accountId?: AccountId, options?: UseQueryOptions<Account>) {
  return useQuery(accountsKeyFn(accountId!), () => getUserAccount(accountId!), {
    ...options,
    enabled: (options?.enabled ?? true) && accountId != null,
  });
}
